import * as React from 'react';
const SvgAwards = (props) => (
  <svg viewBox="0 0 124 122" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="m64.737 32.539 6.705 13.686a3.054 3.054 0 0 0 2.3 1.683l14.992 2.195c2.505.368 3.506 3.468 1.692 5.248L79.579 66.004a3.099 3.099 0 0 0-.88 2.724l2.561 15.043c.429 2.513-2.19 4.43-4.43 3.243L63.42 79.91a3.036 3.036 0 0 0-2.841 0l-13.41 7.104c-2.24 1.186-4.858-.73-4.43-3.243l2.56-15.043a3.094 3.094 0 0 0-.879-2.724L33.574 55.35c-1.811-1.78-.813-4.88 1.692-5.248l14.991-2.195a3.054 3.054 0 0 0 2.3-1.683l6.706-13.686c1.12-2.287 4.357-2.287 5.477 0h-.003Z"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m91.245 42.698 2.187-4.485a2.704 2.704 0 0 1 4.878 0l5.961 12.266c.406.819 1.161 1.384 2.051 1.501l13.355 1.97c2.226.331 3.116 3.12 1.49 4.719l-9.658 9.535a2.813 2.813 0 0 0-.774 2.457l2.284 13.475c.387 2.262-1.955 3.978-3.948 2.905l-11.942-6.357a2.62 2.62 0 0 0-2.516 0l-5.594 2.984M34.98 83.668l-5.592-2.984a2.62 2.62 0 0 0-2.517 0L14.93 87.041c-1.994 1.073-4.336-.643-3.949-2.905l2.284-13.475a2.811 2.811 0 0 0-.774-2.457L2.833 58.67c-1.626-1.6-.735-4.388 1.49-4.72l13.355-1.969c.89-.117 1.645-.682 2.052-1.501l5.96-12.266a2.704 2.704 0 0 1 4.878 0l2.187 4.485M62 2.548v11.7M62 107.848v11.7M91.031 10.384 85.225 20.52M38.774 101.577l-5.806 10.135M91.031 111.712l-5.806-10.135M38.774 20.519l-5.806-10.135"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgAwards;
